import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  visitCount: any = 0;
   dashboardRoute: string = '/home';
  roleId:any;
   currentYear: number = new Date().getFullYear();
  constructor(private commonservice: CommonService,private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.roleId = this.authService.currentUserValue?.roleId;

    this.commonservice.incrementVisit().subscribe({
      next: (response: any) => {
        this.visitCount = response.data.visitCount;
      },
      error: (err) => {
        console.error("Error incrementing visit:", err.message);
      }
    });
  this.authService.currentUserSubject.subscribe(user => {
      if (!user) {
        this.dashboardRoute = '/home';
        return;
      }

      this.roleId = user.roleId;

      this.dashboardRoute = this.roleId === 1 ? '/admin/AdminDash' : '/dashboard';
    });
  }
  }


